module.exports = {"sortorder":{"labels":{"sortOrder":"Sort order","sortOrderInfo":"Sorting: Lowest number first, then by name.<br>Suggestion: multiples of 100, easier to place items in between.<br>Identical sort orders will be sorted by name.<br><strong>Unless you need to change, leave the default sort at 1000</strong>"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/SortOrder/sortorder-en.json
// module id = BGet
// module chunks = 18